import { useParams } from "react-router-dom";

import { IParams, RouteParams } from "../types";

export const useRouteParams = () => {
	const { locationId, tab } = useParams<IParams>();

	if (!locationId) return undefined;

	return {
		locationId: parseInt(locationId),
		tab,
	} as RouteParams;
};
